import React from 'react';
import { Link } from 'react-router-dom';

const LegalFooter = () => {
  const openCookiePreferences = (e) => {
    e.preventDefault();
    window.dispatchEvent(new Event('open-cookie-preferences'));
  };

  return (
    <div
      data-testid="legal-footer"
      style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '24px',
        flexWrap: 'wrap',
        padding: '12px 16px',
        fontFamily: 'var(--font-body)',
        fontWeight: 300,
        fontSize: '0.72rem',
        letterSpacing: '0.04em',
      }}
    >
      <Link to="/privacy" style={{ color: 'rgba(163, 163, 163, 0.45)', textDecoration: 'none' }}>Privacy</Link>
      <Link to="/terms" style={{ color: 'rgba(163, 163, 163, 0.45)', textDecoration: 'none' }}>Terms</Link>
      <Link to="/do-not-sell" style={{ color: 'rgba(163, 163, 163, 0.45)', textDecoration: 'none' }}>Do Not Sell</Link>
      <a href="#" onClick={openCookiePreferences} style={{ color: 'rgba(163, 163, 163, 0.45)', textDecoration: 'none', cursor: 'pointer' }}>Cookie</a>
    </div>
  );
};

export default LegalFooter;
